import {typeExport} from "../../../../../redux/store/type";

const reducerLoginEnterPhoneScreen = (state = { NoInternetDialog: false, results: null ,  isLoading:false, }, action) => {
    switch (action.type) {
        case typeExport.LoginEnterPhoneScreen_SERVICE_PENDING:
            return Object.assign({}, state, {
                NoInternetDialog: false,
                isLoading:true ,
                results:null
            });
        case typeExport.LoginEnterPhoneScreen_SERVICE_ERROR:
            return Object.assign({}, state, {
                NoInternetDialog: true,
                isLoading:false ,
                error: action.error
            });
        case typeExport.LoginEnterPhoneScreen_SERVICE_SUCCESS:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,

            });

            case typeExport.LoginEnterPhoneScreen_SERVICE_REFRESH:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,
            });

        default:
            return state;
    }
}

export default reducerLoginEnterPhoneScreen;
